import { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useShowRankingsSpotifyMonths } from "../rankings-api";

export function ShowRankingsSpotifyMonths() {
    const navigate = useNavigate();
    const { accountID, showID, month } = useParams();
    const { isLoading, data: months } = useShowRankingsSpotifyMonths(
        accountID,
        showID
    );

    useEffect(() => {
        if (!month && months?.length)
            navigate(months[0].substring(0, 10), { replace: true });
    }, [month, months]);

    if (isLoading) return <p>Loading...</p>;

    return (
        <>
            {!months?.length ? (
                <p>Spotify rankings are not available for this show.</p>
            ) : null}
            <Outlet />
        </>
    );
}
